import React from 'react';
import { Grid } from '@material-ui/core';

import { AppointmentDateTime } from './Fields/AppointmentDateTime';
import { BorrowerName } from './Fields/BorrowerName';
import { CoBorrowerName } from './Fields/CoBorrowerName';
import { AdditionalBorrowers } from './Fields/AdditionalBorrowers';
import { SignerType } from './Fields/SignerType';
import { PartialSigning } from './Fields/PartialSigning';
import { AdditionalClientEmail } from './Fields/AdditionalClientEmail';
import { SignerAddress } from './Fields/SignerAddress';
import { PropertyLocation } from './Fields/PropertyLocation';
import { SignerPhone } from './Fields/SignerPhone';
import { BorrowerEmail } from './Fields/BorrowerEmail';
import { SpecialInstruction } from './Fields/SpecialInstruction';

import { useStyles } from './Styles/Fields';

const OrdersForm = ({ location, values, errors, touched, handleChange, handleBlur, setFieldValue, disabled }) => {
  const classes = useStyles();

  return (
    <>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <AppointmentDateTime
          location={location}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <BorrowerName
          location={location}
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <CoBorrowerName
          location={location}
          values={values}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <AdditionalBorrowers
          location={location}
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2} alignItems='center'>
            <SignerType
              location={location}
              values={values}
              handleChange={handleChange}
              disabled={disabled}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2} alignItems='center'>
            <PartialSigning
              location={location}
              values={values}
              errors={errors}
              handleChange={handleChange}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </Grid>
      { location === 'location_one' &&
        <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
          <AdditionalClientEmail
            location={location}
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            handleBlur={handleBlur}
            disabled={disabled}
          />
        </Grid>
      }
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <SignerAddress
          location={location}
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <PropertyLocation
          location={location}
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <SignerPhone
          location={location}
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <BorrowerEmail
          location={location}
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          disabled={disabled}
        />
      </Grid>
      <Grid className={classes.gridRoot} container spacing={2} alignItems='center'>
        <SpecialInstruction
          location={location}
          values={values}
          handleChange={handleChange}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

export { OrdersForm };
